import { render, staticRenderFns } from "./SaleInfo.vue?vue&type=template&id=4cf4500d&scoped=true&"
import script from "./SaleInfo.vue?vue&type=script&lang=js&"
export * from "./SaleInfo.vue?vue&type=script&lang=js&"
import style0 from "./SaleInfo.vue?vue&type=style&index=0&id=4cf4500d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf4500d",
  null
  
)

export default component.exports